import { max } from '../utils';

// random int in [min, max)
export function randomInt(max: number, min = 0) {
  // Math.random -> [0, 1)
  return Math.floor((Math.random() * (max - min)) + min);
}

// TODO: random string

// 暗改数据 y=a(x-b)^(1/3)+2b
export const newSmartData = (min: number, double: number) => {
  const a = (2 * double - min) / pow1_3(double);
  return (n: number) => max(a * pow1_3(n - double) + 2 * double, n);
};
// eslint-disable-next-line camelcase
const pow1_3 = (n: number) => (n >= 0
  ? n ** (1 / 3)
  : -((0 - n) ** (1 / 3))); // fix: Math.pow 无法处理负数的问题
